import i18next from 'i18next';
import * as yup from 'yup';

export const schema = yup.object().shape({
  email: yup.string().email(i18next.t('validation.invalidEmail')).nullable(),
  firstName: yup
    .string()
    .required(i18next.t('validation.required.firstName'))
    .min(2, i18next.t('validation.textTooShort')),
  lastName: yup
    .string()
    .required(i18next.t('validation.required.lastName'))
    .min(2, i18next.t('validation.textTooShort')),
  birthday: yup.date().nullable(),
});
